import React, { Suspense, lazy } from 'react';
import Loader from './loader';

const TabEvents = lazy(() => import('./index'));

function TabEventsLazy(props) {
    return (
        <Suspense fallback={<Loader />}>
            <TabEvents {...props} />
        </Suspense>
    );
}

export default TabEventsLazy;
export { TabEventsLazy };



// WEBPACK FOOTER //
// ./src/routes/main/userprofile/tab-events/lazy.js